import { z } from 'zod';
import { financingServiceConfigSchema } from '../configurations/FinancingServiceConfig.js';
import { servicesProviderGenericDataSchema, agentSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderFinancingDataSchema = servicesProviderGenericDataSchema.extend({
    config: z.object({
        [Services.FINANCING]: financingServiceConfigSchema,
    }),
    agents: z.array(agentSchema),
});

export { servicesProviderFinancingDataSchema };
//# sourceMappingURL=ServicesProviderFinancingData.js.map
